import { Component } from 'react';
import { PropTypes } from 'prop-types';
import cornerstoneTools, { external } from 'cornerstone-tools';
import qs from 'query-string';

export default class HeatmapRender extends Component {
  static propTypes = {
    heatmap: PropTypes.object,
    element: PropTypes.any,
    viewportIndex: PropTypes.number.isRequired,
    context: PropTypes.object,
  };

  getHeatmapData = () => {
    let canvas = this.props.heatmap.canvas;
    if (!canvas) return;

    const newCanvas = document.createElement('canvas');
    newCanvas.width = canvas.width;
    newCanvas.height = canvas.height;
    let ctx = canvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    if (this.props.context.opacity < 100) {
      const pixelData = imageData.data;
      const opacity = this.props.context.opacity * 0.01;
      for (let i = 0; i < pixelData.length; i += 4) {
        pixelData[i + 3] *= opacity;
      }
    }
    ctx = newCanvas.getContext('2d');
    ctx.putImageData(imageData, 0, 0);
    return newCanvas;
  };

  addHeatmapTool = () => {
    const { from } = qs.parse(window.location.search);
    const heatmapTool = cornerstoneTools.getToolForElement(
      this.props.element,
      'Heatmap'
    );
    if (!heatmapTool) {
      setTimeout(() => this.addHeatmapTool(), 100);
      return;
    }
    cornerstoneTools.clearToolState(this.props.element, heatmapTool.name);
    const eventData = {
      element: this.props.element,
      data: {
        heatmap: this.getHeatmapData(),
        alpha: from === 'report' ? 1 : 0.3, //热力图透明度
      },
    };
    if (eventData.data.heatmap) heatmapTool.addNewMeasurement(eventData);

    external.cornerstone.updateImage(eventData.element);
  };

  componentDidUpdate(prevProps) {
    const { heatmap, context } = this.props;
    const { heatmap: prevHeatmap, context: prevContext } = prevProps;
    if (heatmap && context) {
      const canvas = heatmap.canvas;
      const prevCanvas = prevHeatmap && prevHeatmap.canvas;
      if (
        context.activeId !== prevContext.activeId ||
        context.opacity !== prevContext.opacity ||
        canvas !== prevCanvas
      ) {
        this.addHeatmapTool();
      }
    }
  }

  render() {
    return null;
  }
}
